import React from "react";
import "./onlyPortrait.scss"


const OnlyPortrait = () => {
  return (
    <div className="onlyPortrait">
    </div>
  );
};

export default OnlyPortrait;
